/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Downloadtitle1Inputs */

const he_extension_downloadtitle1 = /** @type {(inputs: Extension_Downloadtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`להורדת התוסף`)
};

const en_extension_downloadtitle1 = /** @type {(inputs: Extension_Downloadtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the Extension`)
};

/**
* | output |
* | --- |
* | "Download the Extension" |
*
* @param {Extension_Downloadtitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_downloadtitle1 = /** @type {((inputs?: Extension_Downloadtitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Downloadtitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_downloadtitle1(inputs)
	return en_extension_downloadtitle1(inputs)
});
export { extension_downloadtitle1 as "extension_downloadTitle" }